module.exports = __webpack_public_path__ + "img/trianglify-bw-50@2x.37c358f2.png";